import axios from "axios";
import Event from "../models/Event";
import Order from "../models/Order";

const domain = process.env.REACT_APP_API_URL;

const APIInterface = {
    login: (data = {email:"", password:"", device_name: "client_login"}) => {
        return new Promise((resolve, reject) => {
            axios.defaults.withCredentials = true;
            axios.get(`${domain}/sanctum/csrf-cookie`)
            .then(_response => {
                axios.post(`${domain}/api/request/token`, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
            })
            .catch((error) => {
                reject(error);
            });
        })

    },

    event: () => {
        return new Promise((resolve, reject) => {
            axios.defaults.withCredentials = true;
            axios.get(`${domain}/api/event`)
            .then((response) => {
                resolve(Event.fromJSON(response.data));
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    createOrderPaypal: (order) => {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('mainEmail', order.mainEmail);
            formData.append('event_id', order.event_id);
            formData.append('total', order.total);
            if(order.paypalId) {
                formData.append('paypalId', order.paypalId);
            }
            formData.append('attendees', JSON.stringify(order.attendees.map((attendee) => ({
                fullName: attendee.fullName,
                email: attendee.email,
                phoneNumber: attendee.phoneNumber,
                age: attendee.age,
                birthDate: attendee.birthDate,
                gender: attendee.gender,
            }))));
            order.attendees.forEach((attendee, index) => {
                if(attendee.attachment) {
                    formData.append(`attendees.${index}.attachment`, attendee.attachment);
                }
                if(attendee.responsibilityLetter) {
                    formData.append(`attendees.${index}.responsibilityLetter`, attendee.responsibilityLetter);
                }
            });

            axios.post(`${domain}/api/paypal/order`, formData)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
        });
    },
    updateOrderPaypal: (order) => {
        return new Promise((resolve, reject) => {
            axios.put(`${domain}/api/paypal/order`, order, {
                headers: {
                    "Content-Type": 'application/json'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        })
    },
    resendTickets: (email) => {
        return new Promise((resolve, reject) => {
            axios.post(`${domain}/api/tickets/resend`, { email }, {
                headers: {
                    "Content-Type": 'application/json',
                },
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    createOrder: (token, order = new Order()) => {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('state', order.state || '');
            formData.append('city', order.city || '');
            formData.append('decanato', order.decanato || '');
            formData.append('period_year', order.periodYear || new Date().getFullYear());
            formData.append('period_quincena', order.periodQuincena || 1);
            formData.append('notes', order.loadNotes || '');
            if(order.decanatoAttachment) {
                formData.append('attachment', order.decanatoAttachment);
            }
            formData.append('attendees', JSON.stringify((order.attendees || []).map((attendee) => ({
                fullName: attendee.fullName || null,
                phoneNumber: attendee.phoneNumber || null,
            }))));

            axios.post(`${domain}/api/order`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    orders: (token) => {
        return new Promise((resolve, reject) => {
            axios.get(`${domain}/api/user/orders`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            })
        });
    },
    addUser: (token, data = {email: '', password: '', phone_number: ''}) => {
        return new Promise((resolve, reject) => {
            axios.post(`${domain}/api/user`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    dashboard: (token) => {
        return new Promise((resolve, reject) => {
            axios.get(`${domain}/api/dashboard`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    users: (token) => {
        return new Promise((resolve, reject) => {
            axios.get(`${domain}/api/users`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    decanatoLoadsAdmin: (token, params = {}) => {
        return new Promise((resolve, reject) => {
            axios.get(`${domain}/api/admin/decanato-loads`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    validateTicket: (token, code) => {
        return new Promise((resolve, reject) => {
            axios.get(`${domain}/api/code/${encodeURIComponent(code)}`, {
                headers: {
                    "Content-Type": 'application/json',
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    updateTicket: (token, code, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`${domain}/api/code/${encodeURIComponent(code)}`, payload, {
                headers: {
                    "Content-Type": 'application/json',
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
        });
    }
}

export default APIInterface;